// Moves the product gallery to the selected variant's image.
// Added 30 Aug 2026. Horizon dispatches variant:update with the correct
// featured_media but never tells slideshow-component to move.
document.addEventListener('variant:update', (e) => {
  const pos = e.detail?.resource?.featured_media?.position;
  if (!pos) return;
  const s = document.querySelector('slideshow-component');
  if (s) s.select(pos - 1);
});